import axios from '@/utils/api.request'
let previousUrl = '/api'
// 工作时间设置查询时间
export const getWorkTime = () => {
	return axios.request({
		url: `${previousUrl}/worktime`,
		method: 'get'
	})
}

export const setWorkTime = (data) => {
	return axios.request({
		url: `${previousUrl}/worktime`,
		data: data,
		method: 'post'
	})
}
